import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb'
import ErrorPage from '../../components/ErrorPage/ErrorPage'
import WriteReview from '../../components/WriteReview/WriteReview'
import WriteReviewSubmitted from '../../components/WriteReview/WriteReviewSubmitted'

import * as Styled from './ReviewsPage.styles'

const ReviewsPage = () => {
  const { productName, productId, media } = useSelector(state => state.productStore.data)
  const { errorCode, errorDetail } = useSelector(state => state.productStore.meta)
  const [pageView, setPageView] = useState('form')
  const [submitResponse, setSubmitResponse] = useState('')

  const breadcrumb = [
    {
      id: productId,
      name: productName,
      url: `/product/${productId}`,
      type: 'product'
    }
  ]

  const onSubmit = () => {
    setSubmitResponse({})
    setPageView('submit')
  }

  if (errorCode || errorDetail) {
    return <ErrorPage failureStatus={errorCode || 404} />
  }

  return (
    <Styled.Container className='pdp-main'>
      <div className='container'>
        <section className='xs-12--none'>
          <Breadcrumb className='xs-row pdp-breadcrumbs' ancestors={breadcrumb} />
        </section>

        <Styled.Main>
          {pageView === 'form' && <WriteReview productName={productName} images={media?.images} onSubmit={onSubmit} />}
          {pageView === 'submit' && <WriteReviewSubmitted submitResponse={submitResponse} />}
        </Styled.Main>
      </div>
    </Styled.Container>
  )
}

export default ReviewsPage
